<div
  class="offcanvas offcanvas-end custom-sidebar"
  tabindex="-1"
  #sidebarElement
>
  <!-- Header -->
  <div
    class="drawer-offcanvas-header d-flex justify-content-between align-items-center pb-0"
  >
    <div>
      <div class="offcanvas-title">{{ title }}</div>
    </div>

    <app-icon [icon]="'CLOSE'" (click)="closeDrawer()"></app-icon>
  </div>

  <!-- Body -->
  <div class="offcanvas-body">
    <div class="form-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>
